/* eslint 'no-useless-escape':'off' */

import React, {Component} from 'react';
import { Col, Button, FormGroup, Label } from 'reactstrap';
import { closeModalPopUp } from '../../../../action/modalStateAction';
import { GetRegularExpresions } from '../../../../action/EmployeeAction';
import { PostTenantEmployeesDetailsAction, PutTenantEmployeesDetailsAction, CheckIsLogOnNameExists } from '../../../../action/tenantAction';
import {connect} from 'react-redux';
import {Icon} from 'semantic-ui-react';
import { sendSingleAmplitudeEvent } from 'amplitude/amplitude';

let ErrLogOnName=true, ErrFName=true, ErrLName=true, ErrEmail=true, ErrPwd=true, ErrConfirmPwd=true, ErrConfirmEmail=true, TenantID=0, isEdit=false;
var UserDts = [];
const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

const ErrorPadding = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'border': '2px solid #D42D27',
    'height': '40px',
    'padding': '10px',
    'float': 'left',
    'background-color': '#FFFFFF',
    'font-size': '13px',
    'margin-bottom': '0px',
    'margin-top': '3px'
};

class AddWOEmployee extends Component{
    constructor(props){
        super(props);
        this.state={
            userID: 0,
            error_msg: false,
            duplicateerror_msg: false,
            ErrorDetails : "An entry is required.",
            InvalidEmail: false,
            MismatchEmail: false,
            isError: false,
            PasswordErrorMsg: "An entry is required."
        };
    }

    componentWillMount(){
        this.props.GetRegularExpresions();
        TenantID = this.props.parentToChildData[1];
        UserDts = this.props.parentToChildData[2];
        isEdit = this.props.parentToChildData[3];
        this.setState({userID : this.props.parentToChildData[0]});
    }

    onCancel(){
        isEdit = false;
        this.OnClearErrors();
        this.props.closeModalPopUp("close");    
    }

    onSaveEmployee(){
        this.setState({duplicateerror_msg: false, ErrorDetails: "An entry is required.", PasswordErrorMsg: "An entry is required.", isError:false });
        this.OnClearErrors();

        var EmployeeList = [];
        var RegExpPasswordPattern = this.props.getResponse.RegularExpression[1];
        var RegexpPasswordLength = this.props.getResponse.RegularExpression[0];
        var RegExpLogonNamePattern = this.props.getResponse.RegularExpression[5];
        var RegexpLogonNameLength = this.props.getResponse.RegularExpression[4];
        var RegexpEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; 
        var RegExpOnlySpecialCharacters = /^[^a-zA-Z0-9]+$/;
        var RegexpPasswordDuplicatePattern = /([a-z0-9])\1/i;
        var RegexpPasswordDuplicateAllowed = this.props.getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = this.props.getResponse.RegularExpression[2];

        var LogonName = this.refs.user_id.value;
        var FirstName = this.refs.first_name.value;
        var LastName = this.refs.last_name.value;
        var Password = (!isEdit) ? this.refs.pwd.value : null;
        var ConfirmPassword = (!isEdit) ? this.refs.confirm_pwd.value : null;
        var EmployeeEmail = this.refs.email_address.value;
        var ConfirmEmail = this.refs.confirm_email.value;
        var isValidUser = true;
        
        //validating fields - empty fields, duplicate user, pwd and confirm pwd match, email and confirm email match, check valid pwd, email, user format.
        if(LogonName === "" || FirstName === "" || LastName === "" || Password === "" || ConfirmPassword === "" || EmployeeEmail === "" || ConfirmEmail === ""){
           isValidUser = false;
           ErrLogOnName = LogonName !== "" ? true : false;
           ErrFName = FirstName !== "" ? true : false;
           ErrLName = LastName !== "" ? true : false;
           ErrPwd = Password !== "" ? true : false;
           ErrConfirmPwd = ConfirmPassword !== ""  ? true : false;
           ErrEmail = EmployeeEmail !== "" ? true : false;
           ErrConfirmEmail = ConfirmEmail !== "" ? true : false;
           this.setState({isError: true});
        }
        if(LogonName !== "" && LogonName.match(RegExpOnlySpecialCharacters)){
            isValidUser = false;
            ErrLogOnName = false;
            this.setState({isError: true});
        }
        if(LogonName !== "" && (!LogonName.match(RegExpLogonNamePattern) || !LogonName.match(RegexpLogonNameLength))){
            isValidUser = false;
            ErrLogOnName = false;
            this.setState({isError: true});
        }
        if(EmployeeEmail !== "" && (RegexpEmail.test(EmployeeEmail) === 0)){
            isValidUser = false;
            ErrEmail = false;
            this.setState({InvalidEmail : true,isError: true});
        }
        if(EmployeeEmail !== ConfirmEmail && EmployeeEmail !== "" && ConfirmEmail !== ""){
            isValidUser = false;
            ErrEmail = false;
            ErrConfirmEmail = false;
            this.setState({MismatchEmail: true, InvalidEmail: false, isError: true});
        }
        if(!isEdit){
            if (Password !== ""){
                if(!Password.match(RegExpPasswordPattern) || !Password.match(RegexpPasswordLength)){
                    isValidUser = false;
                    ErrPwd = false;
                    this.setState({isError: true, PasswordErrorMsg: "Password you entered is invalid"});
                }
                else if(RegexpPasswordDuplicateAllowed === "False" && Password.match(RegexpPasswordDuplicatePattern)){                      
                    isValidUser = false;
                    ErrPwd = false;  
                    this.setState({isError: true, PasswordErrorMsg:"Password Cannot Contain Repeating Characters"});                    
                }
                else if(RegexpPasswordLogOnNameForPasswordAllowed === "False"){
                    if (LogonName !== "" && Password.toLowerCase().indexOf(LogonName.toLowerCase()) !== -1) {
                        isValidUser = false;
                        ErrPwd = false;
                        this.setState({isError: true, PasswordErrorMsg:"Password Cannot Contain User ID"});
                    }
                }
            }
            if(Password !== ConfirmPassword && ConfirmPassword !== "" && Password !== "" && !isEdit){
                isValidUser = false;
                ErrPwd = false;
                ErrConfirmPwd = false;
                this.setState({isError: true, PasswordErrorMsg:"Password and the confirmation password should be same."});
            }
        }

        //Valid User
        if(isValidUser){
            if(!isEdit){
            EmployeeList.push({TenantUserId: this.state.userID, TenantId: TenantID, FirstName: FirstName, LastName: LastName, LogOnName: LogonName, Password: Password, EmployeeEmail: EmployeeEmail,ZoneIds: []});
            const  actionResponse  =  this.props.CheckIsLogOnNameExists(LogonName);
                actionResponse.then((result) => {
                    if(!this.props.IsUserIdNameExixts){
                    this.props.PostTenantEmployeesDetailsAction(EmployeeList[0]);
                    sendSingleAmplitudeEvent("Create WO/PM Employee User");
                    this.onCancel();
                }
                    else{
                        ErrLogOnName = false;
                    this.setState({ duplicateerror_msg: true, isError: true});
                    }
            })
            }else{ 
                EmployeeList.push({ TenantUserId: this.state.userID, TenantId: TenantID, FirstName: FirstName, LastName: LastName, LogOnName: LogonName, Password: "", IsActive: UserDts.isActive, EmployeeEmail: EmployeeEmail, AllowTemperatureAdjustment: UserDts.allowTemperatureAdjustment, EmployeePreference: UserDts.employeePreference, ZoneIds: UserDts.zoneIds, PreferenceUnits : UserDts.preferenceUnits, IsTraneConnectUser: UserDts.isTraneConnectUser}); 
                if(LogonName !== UserDts.logOnName){
                    const  actionResponse1  =  this.props.CheckIsLogOnNameExists(LogonName);
                    actionResponse1.then((result) => {
                        if (!this.props.IsUserIdNameExixts) {
                            this.props.PutTenantEmployeesDetailsAction(EmployeeList[0]);
                            this.onCancel();
                        }
                        else {
                            ErrLogOnName = false;
                            this.setState({ duplicateerror_msg: true, isError: true });
                        }
                    })
                }else{
                    this.props.PutTenantEmployeesDetailsAction(EmployeeList[0]);
                    this.onCancel();
                }
            }
        }
    }

    OnClearErrors(){
        ErrLogOnName=true;
        ErrFName=true;
        ErrLName=true;
        ErrEmail=true;
        ErrPwd=true;
        ErrConfirmPwd=true;
        ErrConfirmEmail=true;
    }

    render(){
        var logonName, firstName, lastName, email, confirmEmail, password, confirmPassword;
        if(isEdit && UserDts !== null && UserDts !== undefined){
            logonName = UserDts.logOnName;
            firstName = UserDts.firstName;
            lastName = UserDts.lastName;
            email = UserDts.employeeEmail;
            confirmEmail = UserDts.employeeEmail;
        }

        return(
            <div>
                <div>
                <FormGroup row>
                    <Col sm={{size: 10}}>
                        <p className="wo_employee_textFont"> {(isEdit) ? "Edit " : "Add "}Tenant Employee </p>
                    </Col>
                    <Col sm={{size: 2}}>
                        <p className="wo_employee_closeicon" onClick={() => {this.onCancel()}}>X</p>
                    </Col>
                </FormGroup>
                </div>
                <div style={{ borderTop:'1px solid #FFFFFF',"margin-top":"10px","margin-bottom":"-10px"}}/>
                <div className="textContainer"> 
                    <Label className="wo_employee_subheaderlbl">Employee Information</Label><br/>
                    <Label  className="wo_employee_legend">Enter information to uniquely identify an employee for work order requests.</Label>
                    
                    <FormGroup row style={{marginBottom:(!ErrLogOnName) ? "0px":"10px"}}>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrLogOnName) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>User ID*</Label>
                            <input type="text"  ref="user_id" className={(!ErrLogOnName) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} defaultValue={logonName} maxLength="320"/>
                            <span hidden={ErrLogOnName}><Icon name='exclamation triangle' style={ErrorSign} />
                                {(this.state.duplicateerror_msg) ? <Label className="wo_employee_errortext">Duplicate Login Name.</Label> : <Label className="wo_employee_errortext">{this.state.ErrorDetails}</Label>}
                            </span>
                        </Col>
                    </FormGroup>

                     <FormGroup row style={{marginBottom:(!ErrFName) ? "0px":"10px"}}>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrFName) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>First Name*</Label>
                            <input type="text" ref="first_name" className={(!ErrFName) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} defaultValue={firstName}/>
                            <span hidden={ErrFName}><Icon name='exclamation triangle' style={ErrorSign} /><Label className="wo_employee_errortext">{this.state.ErrorDetails}</Label></span>
                        </Col>
                    </FormGroup>

                     <FormGroup row style={{marginBottom:(!ErrLName) ? "0px":"10px"}}>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrLName) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>Last Name*</Label>
                            <input type="text" ref="last_name" className={(!ErrLName) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} defaultValue={lastName}/>
                            <span hidden={ErrLName}><Icon name='exclamation triangle' style={ErrorSign} /><Label className="wo_employee_errortext">{this.state.ErrorDetails}</Label></span>
                        </Col>
                    </FormGroup>

                     <FormGroup row style={{marginBottom:(!ErrEmail || !ErrConfirmEmail ) ? "0px":"10px"}}>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrEmail) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>Email Address*</Label>
                            <input type="text" ref="email_address" className={(!ErrEmail) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} defaultValue={email}/>
                            <span hidden={ErrEmail}><Icon name='exclamation triangle' style={ErrorSign} />
                                {(this.state.InvalidEmail) ? <Label className="wo_employee_errortext" style={{marginBottom:'0px'}}>Email id you entered is invalid</Label> : (this.state.MismatchEmail) ? <Label className="wo_employee_errortext"  style={{marginBottom:'0px'}}>Email confirmation does not match email address.</Label> : <Label className="wo_employee_errortext" style={{marginBottom:'0px'}}>{this.state.ErrorDetails}</Label>}
                            </span><br/>
                            <span className="workorderlbl-noentry" style={{fontSize:'9px'}}>Required for employees that need to receive Facility Request email confirmations</span>
                        </Col>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrConfirmEmail) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>Confirm Email Address*</Label>
                            <input type="text" ref="confirm_email" className={(!ErrConfirmEmail) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} defaultValue={confirmEmail}/>
                            <span hidden={ErrConfirmEmail}><Icon name='exclamation triangle' style={ErrorSign} />
                                 {(this.state.MismatchEmail) ? <Label className="wo_employee_errortext">Email confirmation does not match email address.</Label> : <Label className="wo_employee_errortext">{this.state.ErrorDetails}</Label>}
                            </span>
                        </Col>
                    </FormGroup>

                    { (!isEdit) ? 
                      <FormGroup row style={{marginBottom:(!ErrPwd || !ErrConfirmPwd) ? "0px":"10px"}}>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrPwd) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>Password*</Label>
                            <input type="password" ref="pwd" className={(!ErrPwd) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} defaultValue={password}/>
                            <span hidden={ErrPwd} ><Icon name='exclamation triangle' style={ErrorSign} />
                                <Label className="wo_employee_errortext">{this.state.PasswordErrorMsg}</Label> 
                            </span>
                        </Col>
                        <Col sm={{size: 6}}>
                            <Label className={(!ErrConfirmPwd) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>Confirm Password*</Label>
                            <input type="password" ref="confirm_pwd"  className={(!ErrConfirmPwd) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} default={confirmPassword}/>
                            <span hidden={ErrConfirmPwd}><Icon name='exclamation triangle' style={ErrorSign} />
                                <Label className="wo_employee_errortext">{this.state.PasswordErrorMsg}</Label>
                            </span>
                        </Col>
                    </FormGroup> : "" }
                </div>
                <div style={{ borderTop:'1px solid #FFFFFF',"margin-top":"10px","margin-bottom":"-10px"}}/>
                <div style={{marginTop:'15px'}}>
                    <span className="workorderlbl-noentry">*required fields </span> 
                    <div style={{float:'right',"margin-bottom":"-6px"}}>
                        {(this.state.isError) ? <p style={ErrorPadding} ><Icon name='exclamation triangle' style={ErrorSign} /><b>Please correct all errors before continuing.</b></p> : ""}
                        <Button className="wo_cancel_btn" style={{'float': 'right', 'margin-left': '6px',"margin-top":"8px"}} onClick={() => {this.onCancel()}}>CANCEL</Button>
                        <Button className="wo_save_btn" style={{'float': 'right', 'margin-left': '6px',"margin-top":"8px"}} onClick={() => {this.onSaveEmployee()}} >{(isEdit) ? "SAVE" : "ADD"}</Button>
                    </div>
                </div>
            </div>
        )
    };
};

const mapStateToProps = state => {
    return {
        getResponse: state.EmployeeRootReducer,
        IsUserIdNameExixts: state.ViewtenantsRootReducer.IsLogOnNameExists
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetRegularExpresions: () => dispatch(GetRegularExpresions()),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        PostTenantEmployeesDetailsAction: (data) => dispatch(PostTenantEmployeesDetailsAction(data)),
        PutTenantEmployeesDetailsAction: (data) => dispatch(PutTenantEmployeesDetailsAction(data)),
        CheckIsLogOnNameExists: (name) => dispatch(CheckIsLogOnNameExists(name))
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(AddWOEmployee);